import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class TargetService {

    getEventRoute = '/api/target/';

    constructor(private dataService: DataService) {
    };

    getLookUp(refresh: boolean) {
        return this.dataService.getData('/api/vehicletarget/lookup', refresh);
    }

    get(refresh: boolean) {
        return this.dataService.getData('/api/vehicletarget', refresh);
    }

    getdata(data:any, refresh: boolean) {
        return this.dataService.getData('/api/vehicletarget/'+ data.region + '/' +data.division+'/'+data.subdivision+'/'+data.financialyear, refresh);
    }

    getById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/vehicletarget/' + id, refresh);
    }

    save(result: any) {
        return this.dataService.post('/api/vehicletarget', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    delete(id: number) {
        return this.dataService.post('/api/vehicletarget/delete/' + id, null).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getFinancialYearList(refresh: boolean) {
        return this.dataService.getData('/api/vehicletarget/financialyearlookup', refresh);
    }


    
    getHomeconnect(refresh: boolean) {
        return this.dataService.getData2('https://dev.home-connect.co.za/HomeWebapi/api/ServiceChangeRequest/getServiceCancelRequestOnLoading', refresh);
    }



}
